import { render, staticRenderFns } from "./CustomizeLabelShareDrawer.vue?vue&type=template&id=ee285d6c&scoped=true"
import script from "./CustomizeLabelShareDrawer.vue?vue&type=script&lang=js"
export * from "./CustomizeLabelShareDrawer.vue?vue&type=script&lang=js"
import style0 from "./CustomizeLabelShareDrawer.vue?vue&type=style&index=0&id=ee285d6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee285d6c",
  null
  
)

export default component.exports